import { prev, nextAll, prevAll, fadeOut, fadeIn } from '../utils.js';
export function createFilmStripGallery(gallery){
    var stage = gallery.querySelector('.kmsgallery-stage');
    gallery.querySelectorAll('.kmsgallery-thumbnail-image').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            // On some sites a jquery handler is used to track outbound clicks,
            // which will still run when the default is prevented. In that case
            // it will also try to prevent the default, report the analytics hit
            // and then navigate the browser. We need to call stopPopagation to
            // prevent that.
            e.stopPropagation();
            var oldimage = gallery.querySelectorAll(".kmsgallery-stage-image");
            var newimage_html = `<div class="kmsgallery-stage-image" style="opacity:0; background-image:url('${el.dataset.imageUrl.replace("'","'")}');"></div>`;
            var newimage = document.createElement('div');
            newimage.innerHTML = newimage_html;
            newimage = newimage.firstChild;
            //TODO: wait for image to load... loading spinner?
            stage.insertAdjacentElement('beforeend', newimage);
            fadeIn(newimage);
            oldimage.forEach((el) => {
                fadeOut(el);
                setTimeout(() => {el.remove();}, 500);
            });
        });
    });
    //Scroll the filmstrip
    var filmstrip = gallery.querySelector('.kmsgallery-filmstrip');
    function checkSize() {
        if (filmstrip.children.length > 0 && filmstrip.scrollWidth > gallery.clientWidth){
            prev(filmstrip, '.kmsgallery-filmstrip-click.next').style.opacity = 1;
        }
        else {
            prev(filmstrip, '.kmsgallery-filmstrip-click.next').style.opacity = 0;
        }
    }
    checkSize();
    window.addEventListener('resize', checkSize);
    window.addEventListener('load', checkSize);
    if (!document.documentElement.classList.contains('no-touch')){
        filmstrip.style.overflowX = 'scroll';
    }
    var moveSlider = function(sliderControl){
        var slider = nextAll(sliderControl, '.kmsgallery-filmstrip')[0];
        var half = slider.clientWidth / 2;
        if(sliderControl.classList.contains('prev')){
			if (slider.scrollLeft > 0) {
				slider.scrollLeft = slider.scrollLeft - half;
				fadeIn(prevAll(slider, '.kmsgallery-filmstrip-click.next')[0]);
			}
			if (slider.scrollLeft <= 0) {
				slider.scrollLeft = 0;
				fadeOut(sliderControl);
			}
		} else { //next
			if (slider.scrollLeft + slider.clientWidth < slider.scrollWidth) {
				slider.scrollLeft = slider.scrollLeft + half;
				fadeIn(prevAll(slider, '.kmsgallery-filmstrip-click.prev')[0]);
			}
			if (slider.scrollLeft + slider.clientWidth >= slider.scrollWidth) {
				slider.scrollLeft = slider.scrollWidth;
				fadeOut(sliderControl);
			}
		}
	}
    prevAll(filmstrip, '.kmsgallery-filmstrip-click').forEach((el) => {
        el.addEventListener('click', () => {
            moveSlider(el);
        });
    });
}
